import { render } from "./QuantityBarrierQuarterCard.vue?vue&type=template&id=a0a10d08&scoped=true"
import script from "./QuantityBarrierQuarterCard.vue?vue&type=script&lang=js"
export * from "./QuantityBarrierQuarterCard.vue?vue&type=script&lang=js"

import "./QuantityBarrierQuarterCard.vue?vue&type=style&index=0&id=a0a10d08&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a10d08"]])

export default __exports__